import React, { useEffect, useState } from "react";
import { BookText, Eye, SquarePen, Trash2, Plus } from "lucide-react";
import { toast } from "react-toastify";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { Progress } from '@chakra-ui/react';

import "./task.css";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Spinner,
  Text,
  ModalCloseButton,
} from "@chakra-ui/react";
import ProgressBar from "../../../../utils/progressBar/ProgressBar.js";
import { getLeadReladedList } from "../../../../redux/reduxApi/leadReduxApi";
import { addTaskMaster } from "../../../../redux/api/taskMasterApi/taskMasterApi";
import { updateTaskMaster, deleteTaskMaster } from "../../../../redux/api/taskMasterApi/taskMasterApi";
import { updateTaskMasterAction } from "../../../../redux/reduxSlice/TaskMasterSlice";
import { NotificationSendApi } from "../../../../Notification/NotificationApi.js";

export default function Task(props) {
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [taskMasterData, setTaskMasterData] = useState(props.taskMasterData || []);
  const [leadId, setLeadId] = useState(props.leadId || null);
  const [isopen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isTrashOpen, setIsTrashOpen] = useState(false);
  const [scrollBehavior, setScrollBehavior] = React.useState("inside");
  const employeesData = useSelector((state) =>
    state.utils?.userList?.map(({ employees }) => ({
      ...employees,
      label: employees.employeeName,
      value: employees.ROWID,
      email: employees.email,
    }))
  );
  const [rows, setRows] = useState([]);
  const userList = useSelector((state) => state.utils.userList);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const dispatch = useDispatch();
  const [dataToEdit, setDataToEdit] = useState({});
  const [taskMasterROWID, setTaskMasterROWID] = useState("");
  const [deleteROWID, setDeleteROWID] = useState();
  const [idsToDelete, setIdsToDelete] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const permissions = localStorage.getItem("permissions");
  const filterData = JSON.parse(permissions);
  const [notificationEmail, setNotificationEmail] = useState([]);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  
  const TaskTypeOptions = [
    {
      value: "Open",
      label: " 🔵 Open",
      background: "#c7e9ff ",
      color: "#007bff",
    },
    {
      value: "In Progress",
      label: " 🟠 In Progress",
      background: " #f8e5c0",
      color: "rgb(209, 144, 47)",
    },
    {
      value: "Closed",
      label: "🟢 Closed",
      background: "#E0F3CE",
      color: "rgb(104, 126, 83)",
    },
  ];

  const [formData, setFormData] = useState({
    subject: "",
    leadRemark: "",
    description: "",
    dueDate: null,
    taskOwner: null,
    priorite: "",
    taskStatus: "Open",
    masterId: props.leadId || null,
    masterModule: "leads",
    customerName: "",
    mobileNumber: "",
  });

  useEffect(() => {
    if (props.leadData) {
      const fullName = `${props.leadData.firstName || ""} ${props.leadData.lastName || ""}`.trim();
      const leadOwnerData = props.leadData.leadOwner || null;
      const mobileNumberData = props.leadData.contactNumber || "";
      const commentRemarkData = props.leadData.commentRemark || "";
      setFormData(prevData => ({
        ...prevData,
        customerName: fullName,
        taskOwner: leadOwnerData,
        mobileNumber: mobileNumberData,
        leadRemark: commentRemarkData,
      }));
    }
  }, [props.leadData]);

  // Validate individual field
  const validateField = (name, value) => {
    let error = "";
    
    switch (name) {
      case "customerName":
        if (!value?.trim()) {
          error = "Customer Name is required";
        }
        break;
      case "mobileNumber":
        if (!value?.trim()) {
          error = "Mobile Number is required";
        } else if (!/^[0-9]{10}$/.test(value.trim())) {
          error = "Mobile Number must be 10 digits";
        }
        break;
      case "subject":
        if (!value?.trim()) {
          error = "Subject is required";
        } else if (value.trim().length < 3) {
          error = "Subject must be at least 3 characters";
        }
        break;
      case "dueDate":
        if (!value) {
          error = "Due Date is required";
        } else {
          const selectedDate = new Date(value);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (selectedDate < today) {
            error = "Due Date cannot be in the past";
          }
        }
        break;
      default:
        break;
    }
    
    return error;
  };

  // Validate entire form
  const validateForm = () => {
    const newErrors = {};
    
    const customerNameError = validateField("customerName", formData.customerName);
    if (customerNameError) newErrors.customerName = customerNameError;
    
    const mobileNumberError = validateField("mobileNumber", formData.mobileNumber);
    if (mobileNumberError) newErrors.mobileNumber = mobileNumberError;
    
    const subjectError = validateField("subject", formData.subject);
    if (subjectError) newErrors.subject = subjectError;
    
    const dueDateError = validateField("dueDate", formData.dueDate);
    if (dueDateError) newErrors.dueDate = dueDateError;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle field blur
  const handleBlur = (fieldName) => {
    setTouched(prev => ({ ...prev, [fieldName]: true }));
    const error = validateField(fieldName, formData[fieldName]);
    setErrors(prev => ({ ...prev, [fieldName]: error }));
  };

  // Handle input change with validation
  const handleInputChange = (name, value) => {
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Clear error when user starts typing
    if (touched[name]) {
      const error = validateField(name, value);
      setErrors(prev => ({ ...prev, [name]: error }));
    }
  };

  const handleClose = () => {
    closeModel();
    setErrors({});
    setTouched({});
    setIsUpdateMode(false);
    setNotificationEmail([]);
    const fullName = `${props.leadData?.firstName || ""} ${props.leadData?.lastName || ""}`.trim();
    const leadOwnerData = props.leadData?.leadOwner || null;
    const mobileNumberData2 = props.leadData?.contactNumber || "";
    const commentRemarkData2 = props.leadData.commentRemark || "";

    setFormData({
      subject: "",
       leadRemark: commentRemarkData2,
    description: "",
      dueDate: null,
      taskOwner: leadOwnerData || null,
      priorite: "",
      taskStatus: "Open",
      masterId: props.leadId || null,
      masterModule: "leads",
      customerName: fullName || null,
      mobileNumber: mobileNumberData2 || "",
    });
  };

  useEffect(() => {
    setTaskMasterData(props.taskMasterData);
  }, [props.taskMasterData]);

  const fetchRelatedLead = () => {
    setLoading(true);
    try {
      getLeadReladedList(leadId).then((response) => {
        if (response.data.success) {
          setTaskMasterData(response.data.response[2]);
        }
      });
    } catch (error) {
      console.log("error fetching related taskmaster", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRelatedLead();
  }, []);


  const sendNotification = async (payload) => {
  try {
    const resp = await NotificationSendApi(payload);
    console.log("resp of notification", resp);
    return resp; // Return the response
  } catch (error) {
    console.log("notification", error);
    throw error; // Re-throw to handle in calling function
  }
};

const handleSubmit = async (e) => {
  e?.preventDefault();
  
  if (!validateForm()) {
    toast.error("Please fill all the required fields correctly");
    setTouched({
      customerName: true,
      mobileNumber: true,
      subject: true,
      dueDate: true,
    });
    return;
  }

  setShowProgressBar(true);
  
  try {
    const response = await addTaskMaster(formData);
    
    if (response.data.success) {
      const ROWID = response.data.ROWID;
      fetchRelatedLead();
      setShowProgressBar(false);
      toast.success("Task added successfully!");
      closeModel();
      
      // Send notifications if task owner is selected
      if (formData.taskOwner) {
        const selectedUser = employeesData.find(emp => emp.value === formData.taskOwner);
        if (selectedUser) {
          await sendNotification({
            title: "New Task Assigned 🚀",
            body: `Hello, ${selectedUser.label}! A new Task has just been assigned to you by ${
              localStorage.getItem("name") || "someone"
            }. Please review and take action promptly to maximize your conversion opportunity.`,
            email: selectedUser.email,
            userId: selectedUser.value,
            module: "tasks",
            moduleRowid: ROWID,
          });
          console.log("Notification sent successfully to:", selectedUser.label);
        }
      }
    } else {
      toast.error("Unable to add Task, Please try again!");
      console.log("error");
    }
  } catch (error) {
    console.error("API Error", error);
    setShowProgressBar(false);
    toast.error("Failed to add Task. Please try again.");
  }
};

  const toInputDateTime = (dateStr) => {
    if (!dateStr) return "";
    return dateStr.replace(" ", "T").slice(0, 16);
  };

  const handelOnUpdate = async () => {
    if (!validateForm()) {
      toast.error("Please fill all the required fields correctly");
      setTouched({
        customerName: true,
        mobileNumber: true,
        subject: true,
        dueDate: true,
      });
      return;
    }

    setShowProgressBar(true);

    try {
      const updatedData = { ...formData, dueDate: toInputDateTime(formData.dueDate) };
      const response = await updateTaskMaster(taskMasterROWID, updatedData);

      if (response?.data?.success) {
        dispatch(updateTaskMasterAction({ ...updatedData, ROWID: taskMasterROWID }));
        toast.success("Task updated successfully! ✅");
        fetchRelatedLead();
        console.log("response--->",response);
        
        handleClose();
        closeModel();
        setShowProgressBar(false);
        const updateNotification = response.data.response
        console.log("updateNotification",updateNotification);

         if (updateNotification.taskOwner) {
        const selectedUser = employeesData.find(emp => emp.value === formData.taskOwner);
        if (selectedUser) {
          await sendNotification({
            title: "New Task Assigned 🚀",
            body: `Hello, ${selectedUser.label}! A new Task has just been assigned to you by ${
              localStorage.getItem("name") || "someone"
            }. Please review and take action promptly to maximize your conversion opportunity.`,
            email: selectedUser.email,
            userId: selectedUser.value,
            module: "tasks",
            moduleRowid: updateNotification.ROWID,
          });
          console.log("Notification sent successfully to:", selectedUser.label);
        }
      }
        
      } else {
        console.error("Unexpected API response:", response);
        toast.error("Task update failed! ❌");
      }
    } catch (error) {
      console.error("Error updating task:", error);
      toast.error("Task update failed! Please try again.");
    } finally {
      setShowProgressBar(false);
    }
  };

  const handelOnUpdates = (id) => {
    const temp = taskMasterData.find((task) => task.taskMaster.ROWID === id);
    if (temp) {
      setDataToEdit({ ...temp.taskMaster });
      setFormData({ ...temp.taskMaster });
      setTaskMasterROWID(id);
      setIsUpdateMode(true);
      setErrors({});
      setTouched({});
      openModel();
    } else {
      console.error("Task not found!");
    }
  };

  const handleDeleteTask = async (ROWID) => {
    setLoading(true);
    try {
      const response = await deleteTaskMaster(ROWID);
      if (response?.data?.success) {
        toast.success("Task deleted successfully! ✅");
        setTaskMasterData((prevTasks) => prevTasks.filter((task) => task.taskMaster.ROWID !== ROWID));
      } else {
        console.error("Failed to delete task:", response?.data?.message);
      }
    } catch (error) {
      toast.error("Failed to delete task ❌");
      console.error("Error deleting task:", error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    const statusOption = TaskTypeOptions.find((option) => option.value === status);
    return statusOption
      ? {
          backgroundColor: statusOption.background.trim(),
          color: statusOption.color,
        }
      : { backgroundColor: "transparent", color: "inherit" };
  };

  const handleSelectChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      taskStatus: selectedOption ? selectedOption.value : "",
    }));
  };

  const setDataToItemTableRowEmployees = (option) => {
    if (!option) return;
    setRows((prevRows) =>
      prevRows?.map((row, idx) =>
        row.index === option.index
          ? {
              ...row,
              employeesData: option.label || "",
              rowId: option.ROWID || "",
            }
          : row
      )
    );
  };

  const customStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? "silver" : "rgb(93, 135, 255)",
      borderRadius: "10px",
      border: "0.5px solid rgb(196,196,196,0.5) !important",
    }),
    placeholder: (styles) => ({
      ...styles,
      color: "gray",
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      color: "black",
      backgroundColor: "white",
    }),
    option: (styles, { isSelected, isFocused }) => ({
      ...styles,
      backgroundColor: isSelected ? "#f1e9e9;" : isFocused ? "#f1e9e9;" : "white",
      color: isSelected ? "#666" : "#333",
    }),
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    handleInputChange(name, value);
  };

// Handle select all - FIXED
const handleSelectAllRows = () => {
  const allSelected = selectedRows.length === taskMasterData.length;
  if (allSelected) {
    setSelectedRows([]);
  } else {
    const allRowIds = taskMasterData.map((item) => item?.taskMaster?.ROWID).filter(Boolean);
    setSelectedRows(allRowIds);
  }
};

// Handle individual row selection - FIXED
const handleRowSelect = (ROWID) => {
  const isSelected = selectedRows.includes(ROWID);
  let newSelectedRows = [];

  if (!isSelected) {
    newSelectedRows = [...selectedRows, ROWID];
  } else {
    newSelectedRows = selectedRows.filter((rowId) => rowId !== ROWID);
  }
  setSelectedRows(newSelectedRows);
};


  const handleDeleteSelectedTasks = async () => {
    if (selectedRows.length === 0) {
      toast.error("No tasks selected for deletion!");
      return;
    }

    setLoading(true);
    try {
      const responses = await Promise.all(
        selectedRows.map((id) => deleteTaskMaster(id))
      );

      if (responses.every((res) => res?.data?.success)) {
        toast.success("Selected tasks deleted successfully! ✅");
        setTaskMasterData((prevTasks) => 
          prevTasks.filter((task) => !selectedRows.includes(task.taskMaster.ROWID)));
        setSelectedRows([]);
      } else {
        toast.error("Some tasks failed to delete ❌");
      }
    } catch (error) {
      toast.error("Error deleting tasks ❌");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    setSelectedRows([]);

    }
  };

  useEffect(() => {
    setDataToEdit(taskMasterData);
  }, [dataToEdit]);

  const openModel = () => {
    setIsOpen(true);
  };

  const closeModel = () => {
    setIsOpen(false);
    setIsUpdateMode(false);
    const fullName = `${props.leadData?.firstName || ""} ${props.leadData?.lastName || ""}`.trim();
    const leadOwnerData = props.leadData?.leadOwner || null;
    const mobileNumberData = props.leadData?.contactNumber || "";
    setFormData({
      subject: "",
       leadRemark: "",
    description: "",
      dueDate: "",
      taskOwner: leadOwnerData || null,
      priorite: "",
      taskStatus: "Open",
      masterId: props.leadId || null,
      masterModule: "leads",
      customerName: fullName || null,
      mobileNumber: mobileNumberData || "",
    });
  };

  const openTrashModel = () => {
    setIsTrashOpen(true);
  };

  const closeTrashModel = () => {
    setIsTrashOpen(false);
  };

  const employeesName = (id) => {
    if (id) {
      const temp = userList.find((item) => item?.employees?.ROWID === id);
      return temp ? temp?.employees?.employeeName || "N/A" : "N/A";
    } else {
      return "N/A";
    }
  };

  return (
    <>
      {loading && (
        <div className="spinner-overlay">
          <Spinner size="xl" color="pink.500" />
        </div>
      )}
      {showProgressBar && <ProgressBar colorScheme="pink" />}
      {/* <div className="button-container mb-2">
        {selectedRows.length === 0 && (
          <>
            <button className="new-button" onClick={openModel}>
              <Plus size="18px" />
              <span>New</span>
            </button>
          </>
        )}
        {selectedTasks.length > 0 && (
          <button className="new-button" onClick={handleDeleteSelectedTasks} disabled={selectedTasks.length === 0}>
            Delete Tasks
          </button>
        )}
      </div> */}
            <div className="button-container mb-2">
        {selectedRows.length === 0 ? (
          <>
            {filterData?.find((mod) => mod.moduleName === "Lead" && mod.add === true) && (
              <button className="new-button" onClick={openModel}>
                <Plus size="18px" />
                <span>New</span>
              </button>
            )}
          </>
        ) : (
          <div className="d-flex gap-2">
            <button 
              className="new-button delete-button" 
              onClick={handleDeleteSelectedTasks}
            >
              <Trash2 size="16px" />
              <span>Delete Selected ({selectedRows.length})</span>
            </button>
            <button 
              className="cancel-button" 
              onClick={() => setSelectedRows([])}
            >
              Cancel Selection
            </button>
          </div>
        )}
      </div>
      
      <TableContainer
        className="card card-detail"
        style={{
          maxHeight: "60vh",
          width: "100%",
          position: "relative",
          overflowY: "scroll",
          scrollbarColor: "#A0AEC0 #EDF2F7",
          scrollbarWidth: "10px",
        }}
      >
        <Table className="Table" id="Table-to-xls" variant="simple" size="sm">
          <Thead>
            <Th className="th-color">
              <Checkbox checked={isAllSelected} onChange={handleSelectAllRows} />
            </Th>
            <Th>Actions</Th>
            <Th>Customer Name</Th>
            <Th>Mobile Number</Th>
            <Th>Subject</Th>
            <Th>Lead remark</Th>
            <Th>Description</Th>
            <Th>Task Owner</Th>
            <Th>Due Date</Th>
            <Th>Status</Th>
            <Th>Priority</Th>
          </Thead>
          <tbody>
            {Array.isArray(taskMasterData) &&
              taskMasterData.slice((currentPage - 1) * 30, currentPage * 30).map((item, index) => (
                <Tr key={index}>
                  <Td className="Th-color">
                    {/* <Checkbox
                      checked={selectedTasks.includes(item?.taskMaster.ROWID)}
                      onChange={() => handleCheckboxChange(item?.taskMaster.ROWID)}
                    /> */}
                     <Checkbox
                        isChecked={selectedRows.includes(item?.taskMaster?.ROWID)}
                        onChange={() => handleRowSelect(item?.taskMaster?.ROWID)}
                        onClick={(e) => e.stopPropagation()}
                      />
                  </Td>
                  <Td>
                    <div className="d-flex gap-1">
                      <i style={{ cursor: "pointer" }}>
                        <SquarePen color="#ff176b" size="16px" strokeWidth="1" onClick={() => handelOnUpdates(item?.taskMaster.ROWID)} />
                      </i>
                      <i style={{ cursor: "pointer" }}>
                        <Trash2 color="#ff176b" size="16px" strokeWidth="1" onClick={() => handleDeleteTask(item.taskMaster.ROWID)} />
                      </i>
                    </div>
                  </Td>
                  <Td className="font-colors">{item?.taskMaster?.customerName}</Td>
                  <Td className="font-colors">{item?.taskMaster?.mobileNumber}</Td>
                  <Td className="font-colors">{item?.taskMaster?.subject}</Td>
                  <Td className="font-colors">{item?.taskMaster?.leadRemark}</Td>
                  <Td className="font-colors">{item?.taskMaster?.description}</Td>
                  <Td className="font-colors">{employeesName(item?.taskMaster?.taskOwner)}</Td>
                  <Td className="font-colors">{item?.taskMaster?.dueDate?.slice(0, 16)}</Td>
                  <Td
                    className="font-colors text-center"
                    style={{
                      ...getStatusColor(item.taskMaster.taskStatus),
                      borderRadius: "10px",
                    }}
                  >
                    {item.taskMaster.taskStatus}
                  </Td>
                  <Td className="font-colors">{item?.taskMaster?.priorite}</Td>
                </Tr>
              ))}
          </tbody>
        </Table>
      </TableContainer>

      {/* Modal for Add/Update Task */}
      <Modal onClose={handleClose} isOpen={isopen} size="xl" scrollBehavior={scrollBehavior}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{isUpdateMode ? "Update Task" : "Add Task"}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {showProgressBar && (
              <div className="w-100 h-100 bg-white bg-opacity-50 text-center position-absolute z-1 top-0">
                <Progress size="xs" isIndeterminate className="mt-1" colorScheme="pink" />
              </div>
            )}
            <div className="table-responsive">
              <table className="table">
                <tbody>
                  <tr style={{ borderColor: "white" }}>
                    <td>
                      <label htmlFor="customerNameInput" className="form-label">
                        Customer Name<span style={{ color: "red" }}>*</span>
                      </label>
                    </td>
                    <td>
                      <input
                        type="text"
                        className={`form-control ${touched.customerName && errors.customerName ? 'is-invalid' : ''}`}
                        id="customerNameInput"
                        name="customerName"
                        value={formData.customerName}
                        onChange={handleChange}
                        onBlur={() => handleBlur("customerName")}
                        readOnly
                      />
                      {touched.customerName && errors.customerName && (
                        <div className="text-danger small px-2">{errors.customerName}</div>
                      )}
                    </td>
                  </tr>
                  <tr style={{ borderColor: "white" }}>
                    <td>
                      <label htmlFor="mobileNumberInput" className="form-label">
                        Mobile Number<span style={{ color: "red" }}>*</span>
                      </label>
                    </td>
                    <td>
                      <input
                        type="text"
                        className={`form-control ${touched.mobileNumber && errors.mobileNumber ? 'is-invalid' : ''}`}
                        id="mobileNumberInput"
                        name="mobileNumber"
                        value={formData.mobileNumber}
                        onChange={handleChange}
                        onBlur={() => handleBlur("mobileNumber")}
                        readOnly
                      />
                      {touched.mobileNumber && errors.mobileNumber && (
                        <div className="text-danger small px-2">{errors.mobileNumber}</div>
                      )}
                    </td>
                  </tr>

                  <tr style={{ borderColor: "white" }}>
                    <td>
                      <label htmlFor="subjectInput" className="form-label">
                        Subject<span style={{ color: "red" }}>*</span>
                      </label>
                    </td>
                    <td>
                      <input
                        type="text"
                        className={`form-control ${touched.subject && errors.subject ? 'is-invalid' : ''}`}
                        id="subjectInput"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        onBlur={() => handleBlur("subject")}
                      />
                      {touched.subject && errors.subject && (
                        <div className="text-danger small px-2">{errors.subject}</div>
                      )}
                    </td>
                  </tr>

                   <tr style={{ borderColor: "white" }}>
                    <td>
                      <label htmlFor="leadRemarkInput" className="form-label">
                        Lead Remark
                      </label>
                    </td>
                    <td>
                     
                       <textarea placeholder="Lead Remark"
                        className="form-control" id="leadRemarkInput" name="leadRemark" value={formData.leadRemark}
                        onChange={handleChange}
                        onBlur={() => handleBlur("leadRemark")}
                        readOnly
                      ></textarea>
                      {touched.leadRemark && errors.leadRemark && (
                        <div className="text-danger small px-2">{errors.leadRemark}</div>
                      )}
                    </td>
                  </tr>

                  <tr style={{ borderColor: "white" }}>
                    <td>
                      <label htmlFor="descriptionInput" className="form-label">
                        Description
                      </label>
                    </td>
                    <td>
                     
                       <textarea placeholder="Description"
                        className="form-control" id="descriptionInput" name="description" value={formData.description}
                        onChange={handleChange}
                        onBlur={() => handleBlur("description")}
                      ></textarea>
                      {touched.description && errors.description && (
                        <div className="text-danger small px-2">{errors.description}</div>
                      )}
                    </td>
                  </tr>

                  <tr style={{ borderColor: "white" }}>
                    <td>
                      <label htmlFor="dueDateInput" className="form-label">
                        Due Date<span style={{ color: "red" }}>*</span>
                      </label>
                    </td>
                    <td>
                      <input
                        type="datetime-local"
                        className={`form-control ${touched.dueDate && errors.dueDate ? 'is-invalid' : ''}`}
                        id="dueDateInput"
                        name="dueDate"
                        value={formData.dueDate || ''}
                        onChange={handleChange}
                        onBlur={() => handleBlur("dueDate")}
                      />
                      {touched.dueDate && errors.dueDate && (
                        <div className="text-danger small px-2">{errors.dueDate}</div>
                      )}
                    </td>
                  </tr>
                  <tr style={{ borderColor: "white" }}>
                    <td>
                      <label className="form-label">Priority</label>
                    </td>
                    <td>
                      <select
                        className="form-select form-select-sm"
                        name="priorite"
                        value={formData.priorite}
                        onChange={handleChange}
                      >
                        <option value="None">None</option>
                        <option value="Low">Low</option>
                        <option value="Medium">Medium</option>
                        <option value="High">High</option>
                      </select>
                    </td>
                  </tr>
                  <tr style={{ borderColor: "white" }}>
                    <td>
                      <label className="form-label">Task Status</label>
                    </td>
                    <td>
                      <div className="">
                        <Select
                          name="taskStatus"
                          options={TaskTypeOptions}
                          value={TaskTypeOptions.find((option) => option.value === formData.taskStatus) || {}}
                          onChange={handleSelectChange}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          styles={{
                            control: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            menuList: (base) => ({
                              ...base,
                              maxHeight: 200,
                              overflowY: "auto",
                            }),
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                  <tr style={{ borderColor: "white" }}>
                    <td>
                      <label className="form-label">Task Owner</label>
                    </td>
                    <td>
                      <Select
                        name="taskOwner"
                        options={employeesData}
                        value={employeesData.find((opt) => opt.value === formData?.taskOwner) || null}
                        onChange={(selectedOption) => {
                          setNotificationEmail((prev) => {
                            const newObj = { value: selectedOption?.value, email: selectedOption?.email, label: selectedOption?.label };
                            if (newObj.email && !prev.some((item) => item.value === newObj.value)) {
                              return [...prev, newObj];
                            }
                            return prev;
                          });
                          setDataToItemTableRowEmployees(selectedOption);
                          setFormData((prevFormData) => ({
                            ...prevFormData,
                            employeesOptions: selectedOption ? selectedOption.value : "",
                            taskOwner: selectedOption ? selectedOption.value : "",
                          }));
                        }}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menuList: (base) => ({
                            ...base,
                            maxHeight: 200,
                            overflowY: "auto",
                          }),
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              className="create-button p-6"
              style={{ width: "90px", marginRight: "10px" }}
              onClick={(e) => {
                e.preventDefault();
                isUpdateMode ? handelOnUpdate() : handleSubmit();
              }}
            >
              {isUpdateMode ? "Update" : "Submit"}
            </Button>
            <Button onClick={handleClose} className="cancel-button">
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Modal isOpen={isTrashOpen} onClose={closeTrashModel}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Are you sure you want to Delete?</ModalHeader>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <ModalFooter>
            <Button className="create-button" mr={3}>
              Delete
            </Button>
            <Button className="cancel-button" onClick={closeTrashModel}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}